import type { HolidaysInRange } from '../../../api/account/accountApiTypes';
import { holidayNameOf } from '../../../utils/recurrence';

/**
 * The public holidays the month grid shades, by date (`YYYY-MM-DD`) → name,
 * from the tenant's holiday region (M9, #3041) — the same data the series
 * marks. `null` means there is no state data to go by (no region set, or the
 * tenant has no room use case): the chart then keeps shading the nationwide
 * holidays of the tenant's country as it always did, so a tenant that never
 * chose a state sees exactly what it saw before.
 *
 * School holidays are not shaded: the chart only ever shaded public holidays.
 */
export function stateHolidayNames(range: HolidaysInRange | undefined, language: string): Map<string, string> | null {
    if (!range?.region) return null;
    const names = new Map<string, string>();
    for (const day of range.days) {
        const holiday = day.holidays.find((h) => h.kind === 'public');
        if (holiday) names.set(day.date, holidayNameOf(holiday, language));
    }
    return names;
}
